<template>
    <div
        class="card-challenge-select-user-item"
        :class="rankingClass">
        <div class="wr-card-challenge-select-user-item__outer">
            <div class="wr-card-challenge-select-user-item__inner">
                <img
                    :src="userImageLink"
                    class="card-challenge-select-user-item__user-img">
                <span class="card-challenge-select-user-item__username">{{ userItem.username }}</span>
                <span class="card-challenge-select-user-item__last-seen">{{ lastSeenText }}</span>
                <span class="card-challenge-select-user-item__rank">{{ rankText }}</span>
                <button
                    class="btn-challenge-select-user-select"
                    @click="$emit('selectUser', userItem)">
                    <svg class="btn-challenge-select-user-select__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#prefix__clip0_838_67)"><path d="M16 0h-3L3.707 9.293l-1.5-1.5L.793 9.207 3.086 11.5l-1.502 1.502a1.5 1.5 0 101.414 1.414L4.5 12.914l2.293 2.293 1.414-1.414-1.5-1.5L16 3V0z" fill="#2779ED"/></g><defs><clipPath id="prefix__clip0_838_67"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></svg>
                </button>
            </div>
        </div>
        <div class="card-challenge-select-user-item__count-win">
            <span class="card-challenge-select-user-item__count-win-text">{{ userItem.stats.win }}</span>
            <span class="card-challenge-select-user-item__count-win-icon"></span>
        </div>
        <div class="card-challenge-select-user-item__count-loss">
            <span class="card-challenge-select-user-item__count-loss-icon"></span>
            <span class="card-challenge-select-user-item__count-loss-text">{{ userItem.stats.loss }}</span>
        </div>
        <div
            v-if="showRankingGem"
            class="card-challenge-select-user-item__ranking-gem">
            <span class="card-challenge-select-user-item__ranking-gem-icon"></span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
   
    /*
        +---+---+---+--+---+--+---+---+---+---+---+

                    Library Imports

        +---+---+---+--+---+--+---+---+---+---+---+
    */
    import moment from 'moment';


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            userItem: {
                type: Object,
                default: {
                    id: 2,
                    username: "testuser101214",
                    lastActive: 1739145938,
                    rank: 11,
                    stats: {
                        win: 19,
                        loss: 4
                    }
                }
            }
        },

        computed: {

            showRankingGem(){
                return this.userItem.rank <= 10 ? true : false;
            },

            rankingClass(){
                if(this.userItem.rank <= 3){
                    return 'card-challenge-select-user-item__rank-' + this.userItem.rank;
                }
                else if(this.userItem.rank <= 10){
                    return 'card-challenge-select-user-item__rank-10';
                }
                return '';
            },

            userImageLink(){
                // return this.$store.state.api.img + this.userItem.id + '.jpg';
                return this.$store.state.api.getImage + this.userItem.id;
            },

            lastSeenText(){
                moment.locale('tr');
                return moment.unix(this.userItem.lastActive).fromNow();
            },

            rankText(){
                if(this.userItem.rank === 1){
                    return 'BİRİNCİ';
                }
                else if(this.userItem.rank === 2){
                    return 'İKİNCİ';
                }
                else if(this.userItem.rank === 3){
                    return 'ÜÇÜNCÜ';
                }
                else if(this.userItem.rank <= 10){
                    return 'İLK 10';
                }
                return 'Sıra #' + this.userItem.rank;
            },
        },
    };
</script>

<style scoped src="@/css/components/card-challenge-select-user-item.css"></style>